export default __webpack_public_path__ + "static/media/spotSign.b98216dd.svg";